<template>
  <div class="evaluate-box">
    <van-nav-bar safe-area-inset-top
        left-arrow
        @click-left="resultClick"
        title="我的反馈"
        fixed
      />
    <div class="eva-style">
      <van-cell
      required
          title="问题反馈类型"
          @click="feedbackClick"
          is-link
          :value="mapObj[feedBackData.pfType]"
          arrow-direction="down"
        />
        <van-popup
          v-model="pickerVehicleShow"
          position="bottom"
          round
          :style="{ height: '38%' }"
        >
          <van-picker
            title="请选择"
            show-toolbar
            default-index="0"
            value-key="itemValue"
            :columns="feedbackColumns"
            @confirm="vehicleOnConfirm"
            @cancel="vehicleOnCancel"
            
          />
          </van-popup>
        <div class="d2">
            <p>反馈问题描述</p>
            <van-field
                v-model="feedBackData.pfDesc"
                rows="7"
                autosize
                type="textarea"
                placeholder="反馈问题描述"
                show-word-limit
                maxlength="50"
                style="padding: 10px 16px;border-radius: 10px;"
            />
        </div>
        <div class="d2">
            <p>图片</p>
            <van-uploader v-model="fileList" :after-read="afterRead" :before-delete='deleteRead' @oversize="onOversize" :max-count="8" />
        </div>
    </div>
    <div class="btn-sub">
        <van-button color='rag(0,143,255)' @click="submitClick"  :loading="buttonloading" round type="info">提交</van-button>
    </div>
  </div>
</template>

<script>

import Api from "../../api/api";
import { Toast } from 'vant';
import { compressImage } from "../../common/util";
export default {
  data() {
    return {
        value: null,
        message: '',
        pickerVehicleShow: false,
        feedBackData: {
          webType: 1,
          images: []
        },
        feedbackColumns: [{
          itemValue: '要求删除配方',
          itemKey: 10341001
        },{
          itemValue: '配方信息错误',
          itemKey: 10341002
        },{
          itemValue: '不当评论',
          itemKey: 10341003
        },{
          itemValue: '积分相关',
          itemKey: 10341004
        },{
          itemValue: 'App 使用问题及建议',
          itemKey: 10341005
        },{
          itemValue: '无法识别二维码',
          itemKey: 10341007
        },{
          itemValue: '摄像头黑屏/打开摄像头失败',
          itemKey: 10341008
        },{
          itemValue: '无法进入扫码界面',
          itemKey: 10341009
        },{
          itemValue: '扫码无法获得积分',
          itemKey: 10341010
        },{
          itemValue: '其他',
          itemKey: 10341006
        }],
        scanType: '', //扫码类型 1:首页扫码 2：防伪扫码
        mapObj: {},
        fileList: [], // 上传状态
        buttonloading: false,
        loginType:2,//登录类型 1:app 2:web
        appInfo: {},//app信息
    };
  },
  mounted() {
    //注册js方法 app调用
    window.getAppInfo =this.getAppInfo;

    console.log(this.$route.params);
    console.log(this.$route.query);
    if(this.$route.query.scanType) {
      this.scanType = this.$route.query.scanType;
    }
    console.log('this.$route.query.recipeLabel', this.$route.query.recipeLabel);
    if(this.$route.query.recipeLabel !== '我的') {
      this.feedbackColumns = this.feedbackColumns.filter(item => item.itemKey !== 10341001);
    }
    this.getMapList(this.feedbackColumns);
    this.feedBackData.recipeNo = this.$route.query.recipeNo;
    this.feedBackData.formulaNo = this.$route.query.formulaNo;

    let loginType=localStorage.getItem("loginType");
    this.loginType=loginType?loginType:2;
    //app内H5页面 则获取APP信息
    if(this.loginType==1){
      setTimeout(() => {
        if (window.HoLiObject) {
          console.log("getAppInfoAsync1");
          window.HoLiObject.getAppInfoAsync();
        } else {
          console.log("getAppInfoAsync2");
          window.webkit.messageHandlers.HoLiObject.postMessage({
            method: "getAppInfoAsync"
          });
        }
      }, 200);
    }
  },
  methods: {
    getAppInfo(appInfo){
      console.log("appInfo",appInfo);
      this.appInfo=JSON.parse(appInfo);
    },
    resultClick() {
      if(this.loginType==1){
        console.log("goBack",this.scanType);
        if(this.scanType){
          if (window.HoLiObject) {
            window.HoLiObject.goBack();
          } else {
            window.webkit.messageHandlers.HoLiObject.postMessage({
              method: "goBack"
            });
          }
        }else{
          this.$router.go(-1)
        }
      }else{
        this.$router.go(-1)
      }
    },
    // 遍历数据字典返回的数组，用obj对应key的value值
    getMapList(list) {
      const obj = {};
      for (let i = 0; i < list.length; i++) {
        obj[list[i].itemKey] = list[i].itemValue;
      }
      Object.assign(this.mapObj, obj);
      return this.mapObj;
    },
    // 反馈类型下拉弹窗选择确定
    vehicleOnConfirm(item) {
      this.pickerVehicleShow = false;
      this.feedBackData.pfType = item.itemKey;
    },
    // 反馈类型下拉弹窗选择取消
    vehicleOnCancel() {
      this.pickerVehicleShow = false;
    },
    feedbackClick() {
      this.pickerVehicleShow = true
    },
    onChange(value) {
      console.log(value);
    },
    // 反馈信息提交
    submitClick() {
      if(!this.feedBackData.pfType) {
        Toast.fail("问题反馈类型必填");
        return;
      }
      let jsonData = this.feedBackData;
      jsonData.webType = 1;
      this.buttonloading = true;
      console.log(this.appInfo);
      console.log(this.loginType);
      if(!jsonData.pfDesc){
        jsonData.pfDesc="";
      }
      if(this.loginType==1){
        jsonData.pfDesc=jsonData.pfDesc+"\n"+this.appInfo.appSystem+" "+this.appInfo.appVersion;
      }
      //扫码页面传递过来的数据
      if(this.scanType){
        jsonData.pfDesc=jsonData.pfDesc+"\n"+this.scanType;
      }
      console.log(jsonData);
      Api.problemfeedbackSave(jsonData).then((res) => {     
        if (!res.data.success) {
         this.sameData.useRemark = userText;
         Toast.fail("保存失败");
         this.buttonloading = false;
        } else {
         Toast.success("提交成功");
         setTimeout(()=> {
          this.resultClick();
          this.buttonloading = false;
         }, 1000)
        }
      })
    },
     // 上传图片
     afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';

      let compressImageFun = compressImage(file);
      compressImageFun.then((res) => {
        Api.uploadPic(res).then((res) => {
          if (res.status === 200) {
            file.status = 'done';
            this.feedBackData.images.push(res.data)
          } else {
            file.status = 'failed';
            file.message = '上传失败';
          }
        });
      })
    },
    // 删除图片
    deleteRead(event,index) {
      this.fileList.splice(index,1);
    },
    // 图片大小限制
    onOversize() {
      Toast('文件大小不能超过 1M');
    },
  },
};
</script>

<style lang="scss" scoped>
// 导航头
/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
}
.evaluate-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  background-color: rgb(255, 255, 255);
}
.nav-box {
  width: 100%;
  height: 2.9rem;
  background-color: white;
  .van-col-title {
    display: flex;
    justify-content: center;
    h3 {
      line-height: 0.75rem;
      font-size: 1.13rem;
    }
  }
  .van-col-icon {
    margin-top: 0.7rem;
    margin-left: 8px;
  }
  
}
.eva-style {
    // margin-top: 2.9rem;
    // margin-top: calc(3.6rem + constant(safe-area-inset-bottom));
    // margin-top: calc(3.6rem + env(safe-area-inset-bottom));
    
    @supports (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top)) {
      padding-top: calc(48px + constant(safe-area-inset-top));
      padding-top: calc(48px + env(safe-area-inset-top));
    }
    width: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    .d1 {
        width: 90%;
        margin-left: 5%;
        margin-top: 2rem;
        .rate-style {
            margin-left: 1rem;
        }
        span {
            color: #666666;
        }
        /deep/ .van-rate__icon--full {
        color: rgb(255,207,0);
        }
    }
    .d2 {
        width: 91.6%;
        margin-left: 4%;
        margin-top: .6rem;
        p {
          color: #323233;
          font-size: 14px;
        }
        /deep/ .van-cell {
            padding: 0;
            background-color: rgb(243,242,249);
        }
        /deep/ .van-field__control {
            border: 1px solid #f3f2f9;
            background-color: #f3f2f9;
        }
    }
    
  }
  .btn-sub {
    width: 100%;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 20px;
    /deep/ .van-button {
        width: 9rem;
    }
  }
</style>